import Swal from "sweetalert2";

/**
 * Shows a SweetAlert2 popup with dynamic title, message (text or HTML), and icon.
 * @param title - The title of the alert.
 * @param message - The message inside the alert (supports HTML for links).
 * @param icon - The icon type ("success", "error", "warning", "info").
 * @param isHtml - Whether the message contains HTML (default: false).
 */
export function showAlert(
    title: string,
    message: string,
    icon: "success" | "error" | "warning" | "info",
    isHtml: boolean = false,
    onConfirm?: () => void,
): void {
    Swal.fire({
        title,
        [isHtml ? "html" : "text"]: message, // Use 'html' for clickable links, 'text' otherwise
        icon,
        confirmButtonText: "OK",
        background: "var(--clr-white)",
        customClass: {
            confirmButton: "my-custom-button",
        },
    }).then((result) => {
        if (result.isConfirmed && onConfirm) {
            onConfirm();
        }});
}

export { Swal };
